import { createReducer, createAction } from '@reduxjs/toolkit';
import { AuthUser } from 'types/User';
import { SessionSlice } from 'types/State';

export const setHasClosedAdhesionAd = createAction('session/hasClosedAdhesionAd');

export const signedIn = createAction<AuthUser>('session/signedIn');
export const signedOut = createAction('session/signedOut');
export const isPaidReceived = createAction<boolean>('session/isPaidReceived');

const sessionKey = 'is_paid';

export const getIsPaidFromSession = (): boolean => {
  if (typeof window !== 'undefined') {
    const storedValue = sessionStorage.getItem(sessionKey);
    return storedValue ? storedValue === 'true' : false;
  }
  return false;
};

const setIsPaidFromSession = (isPaid: boolean): void => {
  if (typeof window !== 'undefined') {
    sessionStorage.setItem(sessionKey, isPaid.toString());
  }
};

export const sessionInitialState: SessionSlice = {
  hasClosedAdhesionAd: false,
  isSignedIn: undefined,
  isPaid: getIsPaidFromSession(),
};

export const sessionReducer = createReducer(sessionInitialState, {
  [isPaidReceived.type]: (state, action) => {
    setIsPaidFromSession(action.payload);
    return { ...state, isPaid: action.payload };
  },

  [setHasClosedAdhesionAd.type]: (state) => {
    return { ...state, hasClosedAdhesionAd: true };
  },
  [signedIn.type]: (state) => {
    return { ...state, isSignedIn: true };
  },
  [signedOut.type]: (state) => {
    return { ...state, isSignedIn: false };
  },
});
